import { render, staticRenderFns } from "./Contracts.html?vue&type=template&id=10885f22&scoped=true&external"
import script from "./Contracts.js?vue&type=script&lang=js&external"
export * from "./Contracts.js?vue&type=script&lang=js&external"
import style0 from "./Contracts.scss?vue&type=style&index=0&id=10885f22&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10885f22",
  null
  
)

export default component.exports